 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import CHARACTERS from '@/components/characters'
 import PROLOGUE from '@/components/prologue'
 import PARTONE from '@/components/partone'
 import CHAPTERONE from '@/components/chapterone'
 import CHAPTERTWO from '@/components/chaptertwo'
 import CHAPTERTHREE from '@/components/chapterthree'
 import CHAPTERFOUR from '@/components/chapterfour'
 import CHAPTERFIVE from '@/components/chapterfive'
 import CHAPTERSIX from '@/components/chaptersix'
 import CHAPTERSEVEN from '@/components/chapterseven'
 import CHAPTEREIGHT from '@/components/chaptereight'
 import PARTTWO from '@/components/parttwo'
 import CHAPTERNINE from '@/components/chapternine'
 import CHAPTERTEN from '@/components/chapterten'
 import CHAPTERELEVEN from '@/components/chaptereleven'
 import CHAPTERTWELVE from '@/components/chaptertwelve'
 import CHAPTERTHIRTEEN from '@/components/chapterthirteen'
 import CHAPTERFOURTEEN from '@/components/chapterfourteen'
 import CHAPTERFIFTEEN from '@/components/chapterfifteen'
 import CHAPTERSIXTEEN from '@/components/chaptersixteen'
 import CHAPTERSEVENTEEN from '@/components/chapterseventeen'
 import CHAPTEREIGHTEEN from '@/components/chaptereighteen'
 import CHAPTERNINETEEN from '@/components/chapternineteen'
 import CHAPTERTWENTY from '@/components/chaptertwenty'
 import CHAPTERTWENTYONE from '@/components/chaptertwentyone'
 import CHAPTERTWENTYTWO from '@/components/chaptertwentytwo'
 import CHAPTERTWENTYTHREE from '@/components/chaptertwentythree'
 import CHAPTERTWENTYFOUR from '@/components/chaptertwentyfour'
 import CHAPTERTWENTYFIVE from '@/components/chaptertwentyfive'
 import CHAPTERTWENTYSIX from '@/components/chaptertwentysix'
 import CHAPTERTWENTYSEVEN from '@/components/chaptertwentyseven'
 import CHAPTERTWENTYEIGHT from '@/components/chaptertwentyeight'
 import PARTTHREE from '@/components/partthree'
 import CHAPTERTWENTYNINE from '@/components/chaptertwentynine'
 import CHAPTERTHIRTY from '@/components/chapterthirty'
 import CHAPTERTHIRTYONE from '@/components/chapterthirtyone'
 import CHAPTERTHIRTYTWO from '@/components/chapterthirtytwo'
 import CHAPTERTHIRTYTHREE from '@/components/chapterthirtythree'
 import CHAPTERTHIRTYFOUR from '@/components/chapterthirtyfour'
 import CHAPTERTHIRTYFIVE from '@/components/chapterthirtyfive'
 import CHAPTERTHIRTYSIX from '@/components/chapterthirtysix'
 import CHAPTERTHIRTYSEVEN from '@/components/chapterthirtyseven'
 import CHAPTERTHIRTYEIGHT from '@/components/chapterthirtyeight'
 import CHAPTERTHIRTYNINE from '@/components/chapterthirtynine'
 import CHAPTERFORTY from '@/components/chapterforty'
 import CHAPTERFORTYONE from '@/components/chapterfortyone'
 import CHAPTERFORTYTWO from '@/components/chapterfortytwo'
 import EPILOGUE from '@/components/epilogue'
 import LOVE_2 from '@/components/love_2'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import PRAISE from '@/components/praise'
 import ALSOBYLILYPRIOR from '@/components/alsobylilyprior'
 import COPYRIGHT from '@/components/copyright'
 import ABOUTTHEPUBLISHER from '@/components/aboutthepublisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/characters",
 			"name" : "characters",
 			"component" : CHARACTERS
 		},
 		{
 			"path" : "/prologue",
 			"name" : "prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/partone",
 			"name" : "partone",
 			"component" : PARTONE
 		},
 		{
 			"path" : "/chapterone",
 			"name" : "chapterone",
 			"component" : CHAPTERONE
 		},
 		{
 			"path" : "/chaptertwo",
 			"name" : "chaptertwo",
 			"component" : CHAPTERTWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js